import { Box, Flex, Button, useColorModeValue, Image, IconButton, Menu, MenuButton, MenuList, MenuItem, HStack } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { ThemeToggle } from './ThemeToggle'
import { HamburgerIcon } from '@chakra-ui/icons'

// Import logo variants
import LogoBlack from '../assets/default-monochrome-black.svg'
import LogoWhite from '../assets/default-monochrome-white.svg'
import LogoImage from '../assets/logo.png'

export default function Navbar() {
  const bgColor = useColorModeValue('white', 'gray.900')
  const textColor = useColorModeValue('gray.800', 'white')
  const shadowColor = useColorModeValue('sm', 'dark-lg')

  // Choose logo based on color mode
  const logo = useColorModeValue(LogoBlack, LogoWhite)

  const MenuLinks = () => (
    <>
      <RouterLink to="/privacy">
        <Button
          variant="ghost"
          color={textColor}
          _hover={{
            bg: useColorModeValue('gray.100', 'gray.700')
          }}
        >
          Privacy Policy
        </Button>
      </RouterLink>
      <RouterLink to="/terms">
        <Button
          variant="ghost"
          color={textColor}
          _hover={{
            bg: useColorModeValue('gray.100', 'gray.700')
          }}
        >
          Terms of Service
        </Button>
      </RouterLink>
    </>
  )

  return (
    <Box bg={bgColor} px={4} shadow={shadowColor} color={textColor}>
      <Flex h={16} alignItems="center" justifyContent="space-between">
        <RouterLink to="/">
          <Flex alignItems="center">
            <Box
              borderRadius="md"
              overflow="hidden"
              height="36px"
              width="36px"
              marginRight="10px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Image
                src={LogoImage}
                alt="VehicleLogi Logo Icon"
                height="36px"
                objectFit="contain"
              />
            </Box>
            <Image
              src={logo}
              alt="VehicleLogi Text"
              height="25px"
              objectFit="contain"
            />
          </Flex>
        </RouterLink>

        {/* Desktop Navigation */}
        <HStack spacing={4} display={{ base: 'none', md: 'flex' }} alignItems="center">
          <ThemeToggle />
          <MenuLinks />
        </HStack>

        {/* Mobile Navigation */}
        <Box display={{ base: 'block', md: 'none' }}>
          <HStack spacing={2}>
            <ThemeToggle />
            <Menu>
              <MenuButton
                as={IconButton}
                aria-label="Open menu"
                icon={<HamburgerIcon />}
                variant="ghost"
              />
              <MenuList>
                <MenuItem as={RouterLink} to="/privacy">
                  Privacy Policy
                </MenuItem>
                <MenuItem as={RouterLink} to="/terms">
                  Terms of Service
                </MenuItem>
              </MenuList>
            </Menu>
          </HStack>
        </Box>
      </Flex>
    </Box>
  )
}